import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=9bf9f534&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"
import style0 from "./product_list.vue?vue&type=style&index=0&id=9bf9f534&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf9f534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bf9f534')) {
      api.createRecord('9bf9f534', component.options)
    } else {
      api.reload('9bf9f534', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=9bf9f534&scoped=true", function () {
      api.rerender('9bf9f534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/material_management/form/components/product_list.vue"
export default component.exports